export default __webpack_public_path__ + "static/media/n1SendingRate.bd6b553e.png";